'use client'; // Only needed if using Next 13+ app directory with server components

import DOMPurify from 'dompurify';
import styles from './richtextviewer.module.scss'; // optional for custom styling

export default function RichTextViewer({ html }) {
  // Sanitize HTML before rendering
  const cleanHtml = DOMPurify.sanitize(html.replace(/\u00A0/g, ' '));

  return (
    <div
      className={styles.richTextViewer + ' rich-text-viewer'}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
}